import * as React from 'react';
import { AddAttachmentPayload } from '@certhon/models';
import { getDefaultProfile } from '@/features/attachments/defaultProfile';
import { resolveUrl } from '@/lib/api-utils';

/**
 * Attachment URL for a given attachment payload
 *
 * The punchCach function can be used to wrap an errorHandler
 *  to make it try punching the cache before calling the wrapped errorHandler
 *
 * @param attachment
 * @returns [url, punchCache]
 */
export function useAttachmentUrl<T extends (error: Error) => void>(
  attachment: AddAttachmentPayload,
) {
  const { checksum, contentType } = attachment;
  const profile =
    /^video\//.test(contentType) || !getDefaultProfile()
      ? null
      : '/' + getDefaultProfile();
  const [punch, setPunch] = React.useState(false);

  const url = resolveUrl(
    `/attachments/${checksum}${profile || ''}${punch ? '?punch=true' : ''}`,
  );

  // TODO: test
  const punchCache = React.useCallback(
    (handler?: T) => (error: Error) => {
      if (!punch) {
        setPunch(true);
      } else {
        handler?.(error);
      }
    },
    [punch],
  );

  return [url, punchCache] as const;
}
